import { getRoot, wrapRoot, removeRoot } from 'mobx-easy';

import TemplatesRootStore from '../templates-root-store';

export const TEMPLATES_WRAPPER = 'templates';

// Rewrite to mobx on-demand store, without the need to pass it via context
// Can use workflows-root-store.ts as an example
const getStore = () => getRoot<TemplatesRootStore>(TEMPLATES_WRAPPER);

const createRoot = () => {
	try {
		return getRoot<TemplatesRootStore>(TEMPLATES_WRAPPER);
	} catch (error) {
		return wrapRoot({ wrapperName: TEMPLATES_WRAPPER, env: {}, RootStore: TemplatesRootStore });
	}
};

const resetRoot = () => {
	try {
		removeRoot(TEMPLATES_WRAPPER);
	} catch (error) {
		console.warn('[TemplatesRoot] resetRoot error:', error);
	}
};

export const TemplatesRoot = { createRoot, getStore, resetRoot };
